import { useEffect, useState } from "react";
import axios from "axios";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import WhatsAppButton from "@/components/site/WhatsAppButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [settings, setSettings] = useState({
    bot_enabled: false,
    bot_greeting: "",
    whatsapp_enabled: false,
    whatsapp_number: "",
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/settings`);
        if (!cancelled) setSettings(data);
      } catch {
        // silent: widgets stay hidden if settings fetch fails
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="home-page" className="bg-bone text-navy">
      <Header />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ChatWidget enabled={settings.bot_enabled} greeting={settings.bot_greeting} />
      <WhatsAppButton enabled={settings.whatsapp_enabled} number={settings.whatsapp_number} />
    </div>
  );
}
